module.exports = __webpack_public_path__ + "img/partner-5.7c079c35.png";